(function(angular) {
    angular.module('wtApp.wtTracking.errorHandler')
        .factory('WtErrorHttp', wtErrorHttpFactory);

    wtErrorHttpFactory.$inject = ['WtError'];
    function wtErrorHttpFactory(WtError) {
        /**
         * @ngdoc service
         * @name WtErrorHttp
         * @description Webtrekk javascript error thrown during HTTP handling
         */
        return class WtErrorHttp extends WtError {
            constructor(message, url = '', status = '', statusText = '') {
                super(`${message}`);

                this.name = WtErrorHttp.name;

                /**
                 * The requested URL
                 */
                this.url = url;

                /**
                 * The status code of the response when the error occurred
                 * @type {string}
                 */
                this.status = status;

                /**
                 * The response status text of the erroneous response
                 * @type {string}
                 */
                this.statusText = statusText;
            }
        };
    }
})(window.angular);
